import { therapistsPath } from "../therapistsPath";

export const stepsPath = '/steps';
export const stepsFullPath = `${therapistsPath}${stepsPath}`;